export default __webpack_public_path__ + "static/media/Wireframe.562b8ba5.svg";